import { push } from 'redux-first-router';

import { Box, Grid, Text } from '@simplywallst/ui-core';
import { getPath } from '@/router/utils';
import { ROUTE_PUBLIC_NARRATIVE_EDIT } from '@/constants/routes';

import { FairValueTooltip } from './components/FairValueTooltip';
import { TitleWithTooltip } from '../TitleWithTooltip';
import { useSelector } from 'react-redux';
import { getLocationPathname } from '@/redux/location/selectors';
import { useTracking } from 'react-tracking';
import { ValuationFairValue } from '../ValuationFairValue';
import { NarrativeBuildFlow } from './components/NarrativeBuildFlow';

type Props = {
  fairValue: number | undefined | null;
  intrinsicDiscount: number | undefined | null;
  companyId: string;
  companyCurrencyISO: string;
  narrativeId: string | undefined | null;
  isNarrativeOnboardingComplete: boolean;
  isDisabled: boolean;
  openOnboardingFlow: () => void;
  onCreateNarrative: () => void;
};

export const ValuationOptionUserDefined = ({
  fairValue,
  intrinsicDiscount,
  companyCurrencyISO,
  narrativeId,
  isNarrativeOnboardingComplete,
  isDisabled,
  openOnboardingFlow,
  onCreateNarrative,
  companyId,
}: Props) => {
  const pathname = useSelector(getLocationPathname);
  const { trackEvent } = useTracking();

  return (
    <>
      <Box>
        <TitleWithTooltip tooltip={<FairValueTooltip />}>
          My Fair Value
        </TitleWithTooltip>
        <Text typography="tiny" color="textSoft">
          Create your own narrative on this stock, and estimate its Fair Value
          using our Valuator tool
        </Text>
      </Box>
      <Grid gap="8px">
        {fairValue && (
          <ValuationFairValue
            fairValue={fairValue}
            intrinsicDiscount={intrinsicDiscount}
            currencyISO={companyCurrencyISO}
          />
        )}
        <NarrativeBuildFlow
          hasUserDefinedNarrative={!!narrativeId}
          onboardingCompleted={isNarrativeOnboardingComplete}
          showingOnboarding={openOnboardingFlow}
          isDisabled={isDisabled}
          editNarrative={() => {
            trackEvent({
              action: 'click',
              target: 'edit-narrative',
              valuationType: 'user_defined',
            });
            const path = getPath({
              type: ROUTE_PUBLIC_NARRATIVE_EDIT,
              payload: {
                id: narrativeId,
                query: {
                  company: companyId,
                  referrer: pathname,
                },
              },
            });
            push(path);
          }}
          createNarrative={onCreateNarrative}
        />
      </Grid>
    </>
  );
};
